<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết công việc</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/task')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>

        <button
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="handleConfirmCancel"
          :disabled="!showCancelBtn"
        >
          <i class="bx bx-minus"></i>
          Huỷ
        </button>

        <button
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="onEditHandler"
          :disabled="!showEditBtn"
        >
          <b-icon icon="pencil-square" aria-hidden="true" />
          Cập nhật
        </button>
      </div>
      <hr />
    </div>

    <b-container fluid>
      <b-row class="gx-1">
        <b-col cols="12" md="5">
          <b-card class="card-section" v-if="['MO'].includes(taskInfo.applyFor)">
            <div class="header-section">Thông tin merchant owner</div>
            <div class="form-item">
              <div class="form-label">Tên merchant owner</div>
              <div class="form-input">
                <b-link :to="`/customer-support/merchant-owner/${taskInfo.merchantOwnerId}`">
                  {{ taskInfo.merchantOwnerInfo?.ownerName || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Số điện thoại</div>
              <div class="form-input">
                <b-link :href="`tel:${taskInfo.merchantOwnerInfo?.mobile}`">
                  {{ taskInfo.merchantOwnerInfo?.mobile || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Email</div>
              <div class="form-input">
                <b-link :href="`mailto:${taskInfo.merchantOwnerInfo?.email}`">
                  {{ taskInfo.merchantOwnerInfo?.email || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Địa chỉ</div>
              <div class="form-input">
                {{ taskInfo.merchantOwnerInfo?.businessRegistrationAddress || '' }}
              </div>
            </div>
          </b-card>

          <b-card class="card-section" v-if="['MA', 'STORE'].includes(taskInfo.applyFor)">
            <div class="header-section">Thông tin merchant</div>
            <div class="form-item">
              <div class="form-label">Tên merchant</div>
              <div class="form-input">
                <b-link :to="`/customer-support/account/${taskInfo.customerInfoRes?.customerId}`">
                  {{ taskInfo.customerInfoRes?.merchantName || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Số điện thoại</div>
              <div class="form-input">
                <b-link :href="`tel:${taskInfo.customerInfoRes?.mobile}`">
                  {{ taskInfo.customerInfoRes?.mobile || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Email</div>
              <div class="form-input">
                <b-link :href="`mailto:${taskInfo.customerInfoRes?.email}`">
                  {{ taskInfo.customerInfoRes?.email || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Địa chỉ</div>
              <div class="form-input">
                {{ taskInfo.customerInfoRes?.address || '' }}
              </div>
            </div>
          </b-card>

          <b-card class="card-section mt-3" v-if="['STORE'].includes(taskInfo.applyFor)">
            <div class="header-section">Thông tin cửa hàng</div>
            <div class="form-item">
              <div class="form-label">Tên cửa hàng</div>
              <div class="form-input">
                <b-link :to="`/customer-support/store/${taskInfo.storeInfo?.storeId}`">
                  {{ taskInfo.storeInfo?.name || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Địa chỉ</div>
              <div class="form-input">
                {{ taskInfo.storeInfo?.address || '' }}
              </div>
            </div>
          </b-card>

          <b-card class="card-section mt-3">
            <div class="header-section mb-2">Thông tin công việc</div>
            <div class="form-item">
              <div class="form-label">Người xử lý</div>
              <div class="form-input">
                <b-link :to="`/staff/detail/?id=${taskInfo.handlerRes?.userId}`">
                  {{ taskInfo.handlerRes?.name || '' }}
                </b-link>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Nhóm công việc</div>
              <div class="form-input">
                {{ getCategoryName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tên công việc</div>
              <div class="form-input">
                {{ taskInfo?.subCategoryName || '' }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tiêu mục công việc</div>
              <div class="form-input">
                {{ getTaskName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Đối tượng</div>
              <div class="form-input">
                <!-- {{ taskInfo.storeInfo ? 'Cửa hàng' : (taskInfo.customerInfoRes ? 'Merchant account' : 'Merchant owner') }} -->
                {{ getSubject }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Thời gian cần xử lý</div>
              <div class="form-input">
                {{ showEstDate(taskInfo.startIntend, taskInfo.endIntend) }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Hình thức chăm sóc</div>
              <div class="form-input methodCareString">
                {{ getMethodCareName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Trạng thái</div>
              <div class="form-input statusString">
                <b-badge :variant="getStatusType">{{ getStatusName }}</b-badge>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Kết quả</div>
              <div class="form-input statusString">
                {{ getResultName }}
              </div>
            </div>
            <div class="form-item" v-if="taskInfo?.result === EnumTaskResultStatus.FAILED">
              <div class="form-label">Lý do thất bại</div>
              <div class="form-input statusString">
                {{ taskInfo.reasonFailure }}
              </div>
            </div>
            <div class="form-item" v-if="EnumTaskStatus.FINISH === taskInfo.status">
              <div class="form-label">Thời gian xử lý</div>
              <div class="form-input">
                {{
                  taskInfo.methodCare == 'ONLINE'
                    ? showEstDate(taskInfo.startProcessing, taskInfo.endProcessing)
                    : showEstDateByMethodCare(taskInfo)
                }}
              </div>
            </div>

            <!-- <div class="form-item">
              <div class="form-label">{{ getNoteName }}</div>
              <div class="form-input">
                {{ taskInfo.note }}
              </div>
            </div> -->

            <div class="form-item">
              <div class="form-label">Lý do thực hiện công việc</div>
              <div class="form-input">
                {{ taskInfo.note }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Mô tả</div>
              <div class="form-input">
                {{ taskInfo.description }}
              </div>
            </div>
            <div
              class="form-item"
              v-if="taskInfo?.status === 'PROCESSING' && taskInfo?.signContractNl === 1"
            >
              <div class="form-label">Chú ý</div>
              <div class="form-input text-danger">
                Để hoàn thành công việc, cần đủ 2 chữ ký của Merchant và Ngân lượng
              </div>
            </div>

            <div class="form-item" v-if="taskInfo?.status === EnumTaskStatus.CANCELED">
              <div class="form-label">Lý do huỷ</div>
              <div class="form-input">
                {{ taskInfo.reasonCancel }}
              </div>
            </div>

            <div class="form-item">
              <div class="form-label">Ảnh checkin tại điểm</div>
              <div class="form-input">
                <template v-if="taskInfo?.checkInImage?.length > 0">
                  <div
                    class="image-item"
                    v-for="(image, index) in taskInfo.checkInImage || []"
                    :key="index"
                  >
                    <b-img
                      class="image"
                      :src="image.urlImage"
                      v-bind="{ width: 100 }"
                      rounded
                      @click="showImg(image.urlImage, 'Ảnh checkin tại điểm')"
                    />
                    <div class="file-name">{{ getFileName(image.urlImage) }}</div>
                  </div>
                </template>
                <div v-else class="no-image">Không có dữ liệu</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Ảnh checkout tại điểm</div>
              <div class="form-input">
                <template v-if="taskInfo?.checkOutImage?.length > 0">
                  <div
                    class="image-item"
                    v-for="(image, index) in taskInfo.checkOutImage || []"
                    :key="index"
                  >
                    <b-img
                      class="image"
                      :src="image.urlImage"
                      v-bind="{ width: 100 }"
                      rounded
                      @click="showImg(image.urlImage, 'Ảnh checkout tại điểm')"
                    />
                    <div class="file-name">{{ getFileName(image.urlImage) }}</div>
                  </div>
                </template>
                <div v-else class="no-image">Không có dữ liệu</div>
              </div>
            </div>
            <div class="form-item" style="align-items: flex-start">
              <div class="form-label">Ảnh giải trình</div>
              <div class="form-input" style="margin-left: -4px">
                <div
                  class="image-item"
                  v-for="(image, index) in taskInfo.explanationImage || []"
                  :key="index"
                >
                  <b-img
                    class="image"
                    :src="image.urlImage"
                    v-bind="{ width: 100 }"
                    rounded
                    @click="showImg(image.urlImage, 'Ảnnh giải trình')"
                  />
                  <div class="file-name">{{ getFileName(image.urlImage) }}</div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" md="7">
          <b-card class="card-section xs:mt-4">
            <div class="header-section">Thông tin chăm sóc</div>
            <div
              v-for="(task, index) in taskInfo.formDataList || []"
              :key="index"
              class="form-item d-block"
            >
              <li class="">
                <div
                  class="cursor-pointer d-flex align-items-center justify-content-between"
                  @click="toggleTask(index)"
                >
                  <div class="form-label">
                    {{ index + 1 + '. ' + task.formName }}
                  </div>
                  <div class="icon-arrow">
                    <b-icon-chevron-down
                      v-if="!showTask[index]"
                      class="ml-2 font-weight-bold icon"
                    ></b-icon-chevron-down>
                    <b-icon-chevron-up
                      v-else
                      class="ml-2 icon font-weight-bold"
                    ></b-icon-chevron-up>
                  </div>
                </div>
                <b-collapse :id="'my-task-collapse-' + index" v-model="showTask[index]" class="">
                  <ul class="list-task">
                    <li
                      v-for="(taskDetail, index2) in task.taskInFormDataList"
                      :key="(index + 1) * (index2 + 1)"
                    >
                      {{ taskDetail.taskInFormName }}
                      <div class="list-task-image d-flex flex-wrap ml-2">
                        <div class="mt-2" v-if="taskDetail?.images?.length > 0">
                          <b-img
                            class="cursor-pointer mr-3"
                            v-for="(src, index3) in taskDetail.images"
                            :key="index3"
                            rounded
                            @click="showImg(src, taskDetail.taskInFormName)"
                            :src="src"
                          />
                        </div>
                        <p
                          v-else-if="!IsShowImage(taskDetail?.taskInFormCode)"
                          class="no-data mt-1"
                        >
                          Không có ảnh
                        </p>
                      </div>
                    </li>
                  </ul>
                </b-collapse>
              </li>
            </div>
            <div class="form-item d-block">
              <div class="form-label">
                {{ taskInfo?.formDataList?.length + 1 || 0 }}. Ghi chú thông tin chăm sóc
              </div>
              <div class="form-input ml-3">
                {{ taskInfo.afterSaleNote }}
              </div>
            </div>

            <!-- <div
              class="form-item list-support"
              style="align-items: flex-start"
              v-for="(formData, index) in taskInfo.formDataList || []"
              :key="index"
            >
              <div class="form-label">{{ formData.formName }}</div>
              <div class="form-input">
                <ul class="list-task">
                  <li
                    v-for="(task, index2) in formData.taskInFormDataList"
                    :key="(index + 1) * (index2 + 1)"
                  >
                    {{ task.taskInFormName }}
                  </li>
                </ul>
              </div>
            </div> -->

            <!-- <div class="form-item list-support">
              <div class="form-label">Tiểu mục</div>
              <div class="form-input">
                {{ taskInfo.formDataList?.reduce((arr, category) => {arr.push(category.formName); return arr;}, []).join('; ') }}
              </div>
            </div> -->
          </b-card>
          <b-card class="card-section mt-3">
            <div class="header-section">Thông tin cuộc gọi</div>
            <div class="table-responsive text-center p-0">
              <b-table
                striped
                hover
                :items="historyCall"
                :fields="historyCallFields"
                thead-class="thead-light"
                sticky-header="500px"
                responsive
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(toNumber)="data">
                  <strong>{{ data.item.toNumber | encryptPhone }}</strong
                  ><br />{{ data.item.contactName }}
                </template>
                <template #cell(username)="data">
                  <strong>{{ data.item.username }}</strong
                  ><br />{{ data.item.userEmail }}
                </template>
                <template #cell(initCallIoTime)="data">
                  {{ data.item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(createCallIoTime)="data">
                  {{ data.item.createCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}<br />
                  {{ data.item.endCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(timing)="data">
                  {{ getTiming(data.item.endCallIoTime, data.item.createCallIoTime) }}
                </template>
                <template #cell(direction)="data">
                  {{ data.item.direction | formatDirection }}
                </template>
                <template #cell(crmResult)="data">
                  <span v-if="data.item.crmResult"
                    >{{ data.item.crmResult | resultCall(resultStatusCalls) }}
                    <br />
                    {{ data.item.crmNote }}
                  </span>
                </template>
                <template #cell(action)="data">
                  <b-dropdown class="text-center" variant="outline-light">
                    <b-dropdown-item @click="detailCall(data.item.id)" class="dropdown-item"
                      ><span>&nbsp;</span>Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.callId"
                      @click="listenRecord(data.item.callId)"
                      class="dropdown-item"
                      ><span>&nbsp;</span>Nghe ghi âm cuộc gọi
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </b-card>
          <b-card class="card-section mt-3">
            <div class="header-section">Lịch sử hỗ trợ MC thay đổi thông tin</div>
            <div class="table-responsive text-center p-0">
              <b-table
                striped
                hover
                :items="taskInfo.approveHistoryList || []"
                :fields="approveHistoryFields"
                thead-class="thead-light"
                sticky-header="500px"
                responsive
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(createdDate)="data">
                  {{ formatDate(data.item.createdDate, 'DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(statusChangeInfo)="data">
                  {{ mapStatusChangeInfo(data.item.statusChangeInfo) }}
                </template>
                <template #cell(statusApproveMpos)="data">
                  {{ mapStatusApproveMpos(data.item.statusApproveMpos) }}
                </template>
                <template #cell(reason)="data">
                  {{ data.item.reason || '' }}
                </template>
              </b-table>
            </div>
          </b-card>

          <b-card class="card-section xs:mt-4 mt-3" v-if="taskInfo?.collectionData?.questionList">
            <div class="header-section">Thông tin thu thập</div>
            <div
              v-for="(question, index) in taskInfo.collectionData.questionList || []"
              :key="index"
              class="form-item d-block"
            >
              <!-- <li class="">
                <div class="cursor-pointer d-flex align-items-center justify-content-between"
                  @click="toggleCollection(index)">
                  <div class="form-label-collection">
                    {{ index + 1 + ". " + question.questionName }}
                  </div>
                  <div class="icon-arrow">
                    <b-icon-chevron-down v-if="!showCollection[index]"
                      class="ml-2 font-weight-bold icon"></b-icon-chevron-down>
                    <b-icon-chevron-up v-else class="ml-2 icon font-weight-bold"></b-icon-chevron-up>
                  </div>
                </div>
                <b-collapse :id="'my-collection-collapse-' + index" v-model="showCollection[index]" class="">
                  <ul class="list-task">
                    <li v-for="(option, index2) in question.optionResult" :key="(index + 1) * (index2 + 1)">
                      <div v-if="option !== 'OTHER'">
                        {{ option }}
                      </div>
                      <div v-else>
                        Khác: {{ question.otherAnswerResult }}
                      </div>
                    </li>
                  </ul>
                </b-collapse>
              </li> -->
              <div
                class="cursor-pointer d-flex align-items-center justify-content-between"
                @click="toggleCollection(index)"
              >
                <div class="form-label-collection">
                  {{ index + 1 + '. ' + question.questionName }}
                </div>
                <div class="icon-arrow">
                  <b-icon-chevron-down
                    v-if="!showCollection[index]"
                    class="ml-2 font-weight-bold icon"
                  />
                  <b-icon-chevron-up v-else class="ml-2 icon font-weight-bold" />
                </div>
              </div>
              <b-collapse
                :id="'my-collection-collapse-' + index"
                v-model="showCollection[index]"
                class=""
              >
                <ul class="list-task">
                  <template
                    v-if="question.questionType === EnumQuestionType.CONDITIONAL_MULTIPLE_CHOICE"
                  >
                    <template v-if="question.choice">
                      <li
                        v-for="(option, index2) in question.optionResult"
                        :key="(index + 1) * (index2 + 1)"
                      >
                        <span v-if="option !== 'OTHER'">
                          {{ option }}
                        </span>
                        <span v-else> Khác: {{ question.otherAnswerResult }} </span>
                      </li>
                    </template>
                    <template v-else>
                      <li>Không</li>
                    </template>
                  </template>
                  <template v-else-if="question.questionType === EnumQuestionType.YES_NO_QUESTION">
                    <ul class="list-task">
                      <li>{{ question.choice ? 'Có' : 'Không' }}</li>
                    </ul>
                  </template>
                  <template v-else-if="question.questionType === EnumQuestionType.MULTIPLE_CHOICE">
                    <li
                      v-for="(option, index2) in question.optionResult"
                      :key="(index + 1) * (index2 + 1)"
                    >
                      <span v-if="option !== 'OTHER'">
                        {{ option }}
                      </span>
                      <span v-else> Khác: {{ question.otherAnswerResult }} </span>
                    </li>
                  </template>
                  <template v-else-if="question.questionType === EnumQuestionType.SHORT_ANSWER">
                    <li>{{ question.otherAnswerResult }}</li>
                  </template>
                  <template v-else-if="question.questionType === EnumQuestionType.QUIZ">
                    <li>{{ question.optionResult[0] }}</li>
                  </template>
                  <template v-else>
                    <li v-if="typeof question.choice === 'boolean'">
                      {{ question.choice ? 'Có' : 'Không' }}
                    </li>
                    <template v-if="question?.optionResult?.length > 0">
                      <li
                        v-for="(option, index2) in question.optionResult"
                        :key="(index + 1) * (index2 + 1)"
                      >
                        <span v-if="option !== 'OTHER'">
                          {{ option }}
                        </span>
                        <span v-else> Khác: {{ question.otherAnswerResult }} </span>
                      </li>
                    </template>
                    <template v-else>
                      <li v-if="question.otherAnswerResult">{{ question.otherAnswerResult }}</li>
                    </template>
                  </template>
                </ul>
              </b-collapse>
            </div>
          </b-card>
          <!-- note: not delete | will use for next version
          <b-card class="card-section mt-3">
            <div class="header-section">Thu thập thông tin</div>
            <div class="form-item">
              <div class="form-label">Có POS bên khác không?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">POS bên nào?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Có sử dụng trả góp bên khác không?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Trả góp nào?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Có sử dụng QRCODE bên khác không?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">QRCODE bên nào?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tích hợp thanh toán thẻ trên website không?</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Mô tả</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Ảnh giải trình</div>
              <div class="form-input">
                {{  }}
              </div>
            </div>
          </b-card> -->
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="isShowModalImg" centered :title="isTitleModalImg" hide-footer>
      <b-img style="width: 100%" :src="srcImg" rounded />
    </b-modal>

    <!-- <UpdateAFS
      :dataUpdate="dataUpdate"
      :purposesSelected="purposesSelected"
      :fileImage="fileImage"
      :dateRangeProcessing="dateRangeProcessing"
      @updateCalendar="updateCalendar"
      @onHidden="onHidden"
    /> -->
    <PopupConfirmCancel ref="popupConfirmCancelRef" @change="loadData" />
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import { TaskDetail, WorkGroupList, WorkTaskList } from '@/services/customer-support/task'
  import moment from 'moment/moment'
  import pad from 'lodash/pad'
  import { CallIoService } from '@/services/callio.service'
  // import UpdateAFS from "@/components/UpdateAFS.vue";
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
  import mxItemAction from './mx-item-action.js'
  import { nextTick } from 'vue'
  import { v4 as uuidv4 } from 'uuid'
  import {
    TaskStatus,
    TaskResultStatus,
    EnumTaskStatus,
    optionColorStatus,
    TaskMethodCare,
    EnumTaskMethodCare,
    EnumTaskResultStatus,
    EnumQuestionType,
  } from '@/constant/customerSupport'
  import { StaffService } from '@/services/staff.service'
  import PopupConfirmCancel from './components/PopupConfirmCancel'

  const currentUser = JSON.parse(localStorage.getItem('userData'))

  export default {
    name: 'DetailTask',
    components: {
      // UpdateAFS,
      PopupConfirmCancel,
    },
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        // userData: JSON.parse(localStorage.getItem('userData')),
        EnumQuestionType,
        EnumTaskResultStatus,
        showTask: [],
        showCollection: [],
        isLoading: false,
        id: '',
        isShowModalImg: false,
        isTitleModalImg: 'Ảnh giải trình',
        srcImg: '',

        taskCategoryOptions: [],
        taskNameOptions: [],

        taskInfo: {},
        EnumTaskStatus,

        methodCareOptions: TaskMethodCare,
        // popup
        dataUpdate: {},
        purposesSelected: null,
        fileImage: [],
        dateRangeProcessing: {
          startProcessingDate: null,
          endProcessingDate: null,
        },
        dataStaff: [],
        historyCall: [],
        resultStatusCalls: [],
        historyCallFields: [
          { key: 'index', label: 'STT' },
          { key: 'toNumber', label: 'Liên hệ' },
          { key: 'username', label: 'Nhân sự' },
          { key: 'initCallIoTime', label: 'TG khởi tạo' },
          { key: 'createCallIoTime', label: 'TG thực hiện' },
          { key: 'timing', label: 'TG gọi' },
          { key: 'direction', label: 'Chiều gọi' },
          { key: 'crmResult', label: 'Kết quả' },
          { key: 'action', label: 'Thao tác', fixIndex: 999 },
        ],
        approveHistoryFields: [
          { key: 'createdDate', label: 'Thời gian' },
          { key: 'statusChangeInfo', label: 'TT thay đổi TT trên MNP' },
          { key: 'statusApproveMpos', label: 'Trạng thái duyệt mpos' },
          { key: 'reason', label: 'Lý do' },
        ],
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
    },
    async mounted() {
      await this.loadDataType()
      await this.loadData()
      await this.loadDataTask()
      await this.loadSubordinate()
      this.initializeShowTask()
      this.initializeShowCollection()

      // Fetch call history and result status
      if (
        (this.taskInfo.customerInfoRes && this.taskInfo.customerInfoRes.customerId) ||
        (this.taskInfo.merchantOwnerInfo && this.taskInfo.merchantOwnerInfo.merchantOwnerId)
      ) {
        await this.fetchHistory()
        await this.fetchResultStatusCall()
      }
    },

    computed: {
      EnumTaskMethodCare() {
        return EnumTaskMethodCare
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      IsShowImage() {
        return taskInFormCode => {
          switch (taskInFormCode) {
            case 'KT-SERI':
              return false
            case 'KT-PK':
              return false
            case 'KT-MINI':
              return false
            default:
              return true
          }
        }
      },

      showEstDate() {
        return (startDate, endDate) => {
          return startDate && endDate
            ? `${moment(startDate).format('DD/MM/YYYY HH:mm')} - ${moment(endDate).format(
                'DD/MM/YYYY HH:mm'
              )}`
            : ''
        }
      },

      showEstDateByMethodCare() {
        return task => {
          // const checkInData = task?.checkInImage[task?.checkInImage?.length - 1];
          // const checkOutData = task?.checkOutImage[0];
          // return checkInData.uploadTime && checkOutData.uploadTime
          //   ? `${moment(checkInData.uploadTime).format("DD/MM/YYYY HH:mm")} - ${moment(checkOutData.uploadTime).format("DD/MM/YYYY HH:mm")}`
          //   : "";
          if (task?.checkInImage?.length > 0 && task?.checkOutImage?.length > 0) {
            const checkInData = task?.checkInImage[task?.checkInImage?.length - 1]
            const checkOutData = task?.checkOutImage[0]
            return checkInData.uploadTime && checkOutData.uploadTime
              ? `${moment(checkInData.uploadTime).format('DD/MM/YYYY HH:mm')} - ${moment(checkOutData.uploadTime).format('DD/MM/YYYY HH:mm')}`
              : ''
          }

          return ''
        }
      },

      getSubject() {
        const mapSubject = {
          MO: 'Merchant owner',
          MA: 'Merchant account',
          STORE: 'Cửa hàng',
        }

        return mapSubject[this.taskInfo.applyFor] || ''
      },

      getCategoryName() {
        const category = this.taskCategoryOptions.find(
          category => category.code === this.taskInfo.type
        )
        return category ? category.text : ''
      },

      getTaskName() {
        if (!this.taskInfo?.purposes?.length) return ''
        const taskObject = this.taskNameOptions.find(
          task => task.code === this.taskInfo.purposes[0]
        )
        return taskObject ? taskObject.text : ''
      },

      getFileName() {
        return url => {
          if (!url) return ''
          const parts = url.split('/')
          return parts[parts.length - 1]
        }
      },

      getStatusName() {
        const statusCode = this.taskInfo?.status || ''
        if (!statusCode) return ''
        const statusObj = TaskStatus.find(s => s.id === statusCode)
        return statusObj ? statusObj.text : statusCode
      },

      getStatusType() {
        return optionColorStatus[this.taskInfo?.status] || ''
      },

      getResultName() {
        const result = this.taskInfo?.result || ''
        if (!result) return ''
        const statusObj = TaskResultStatus.find(s => s.id === result)
        return statusObj ? statusObj.text : result
      },
      // getNoteName() {
      //   if (this.taskInfo?.status) {
      //     if (this.taskInfo?.status == EnumTaskStatus.FINISH) {
      //       return 'Lý do thực hiện'
      //     } else if (this.taskInfo?.status == EnumTaskStatus.CANCELED) {
      //       return 'Lý do huỷ'
      //     }
      //   }
      //   return 'Lý do công việc'
      // },
      getMethodCareName() {
        const methodCareObj = this.methodCareOptions.find(s => s.id === this.taskInfo?.methodCare)
        return methodCareObj ? methodCareObj.text : ''
      },

      showEditBtn() {
        return (
          // this.dataPermission.includes('CNPS_CSS_TASK_UPDATE') && // có quyền cập nhật
          ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(this.taskInfo?.status) && // trạng thái là NEW || PROCESSING (Mới tạo, Đang xử lý)
            this.taskInfo?.saleId === currentUser?.userId) || // là người xử lý
          ([EnumTaskStatus.NEW].includes(this.taskInfo?.status) && // trạng thái là NEW (Mới tạo)
            (this.taskInfo?.createdBy === currentUser?.userId || // người tạo
              this.dataStaff.some(item => item.id === currentUser?.userId))) // người quản lý của người xử lý
        )
      },
      showCancelBtn() {
        return (
          ([EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(this.taskInfo?.status) &&
            this.taskInfo?.saleId === currentUser?.userId) ||
          ([EnumTaskStatus.NEW].includes(this.taskInfo?.status) &&
            this.taskInfo?.createdBy === currentUser?.userId)
        )
      },
    },
    methods: {
      mapStatusApproveMpos(status) {
        if (!status) return ''
        const map = {
          MPOS_PENDING: 'Chờ duyệt',
          MPOS_ACTIVE: 'Đã duyệt',
          MPOS_DENIED: 'Từ chối',
        }
        return map[status] || status
      },
      mapStatusChangeInfo(status) {
        if (!status) return ''
        const map = {
          NEW: 'Mới tạo',
          SIGNING: 'Đang ký',
          SIGNED_WAITING_APPROVED: 'Đã ký - Chờ duyệt',
          ADDITIONAL: 'Cần bổ sung',
          WAITING_SUPPORT: 'Chờ hỗ trợ',
          CANCELED: 'Đã hủy',
          REJECTED: 'Bị từ chối',
          COMPLETE: 'Hoàn thành',
        }
        return map[status] || status
      },
      initializeShowTask() {
        if (this.taskInfo.formDataList) {
          this.showTask = new Array(this.taskInfo?.formDataList?.length).fill(true)
        }
      },
      toggleTask(index) {
        this.$set(this.showTask, index, !this.showTask[index])
      },
      toggleCollection(index) {
        this.$set(this.showCollection, index, !this.showCollection[index])
      },
      initializeShowCollection() {
        if (this.taskInfo?.collectionData?.questionList) {
          this.showCollection = new Array(this.taskInfo.collectionData?.questionList?.length).fill(
            true
          )
        }
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await TaskDetail(this.id)
          if (res.result) {
            this.taskInfo = res.data
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadDataType() {
        try {
          this.isLoading = true
          const res = await WorkGroupList({
            size: 100,
            page: 1,
          })
          if (res.result) {
            this.taskCategoryOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.groupName,
                code: item.groupCode,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadDataTask() {
        try {
          this.isLoading = true
          const category = this.taskCategoryOptions.find(
            category => category.code === this.taskInfo.type
          )
          if (category) {
            const res = await WorkTaskList({
              size: 100,
              page: 1,
              status: 'APPLYING',
              wkGroupId: category.id,
            })
            if (res.result) {
              this.taskNameOptions = res.data.map(item => {
                return {
                  id: item.id,
                  text: item.taskName,
                  code: item.taskCode,
                }
              })
            } else {
              showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } else {
            showMess(
              this,
              'Error',
              'Không tìm thấy nhóm công việc',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      showImg(src, title) {
        this.isTitleModalImg = title
        this.srcImg = src
        this.isShowModalImg = true
      },

      async onEditHandler() {
        this.$router.push(`/customer-support/task/${this.id}/edit`)
        // try {
        //   this.showLoading = false;
        //   const res = await CalendarAfsService.getTaskAFSDetailById({
        //     id: this.id,
        //   });
        //   if (res.success && res.code == 1000) {
        //     // this.showPopupUpdate(res.data);
        //     this.$router.push(`/customer-support/task/${this.id}/edit`);
        //   } else {
        //     this.showFailMx(res.message);
        //   }
        // } catch (error) {
        //   this.showFailMx(error.message ?? error);
        // } finally {
        //   this.showLoading = false;
        // }
      },

      showPopupUpdate(item) {
        this.dataUpdate = {}
        if (item.handlerRes.userName === currentUser.username) {
          this.onChangeType(item.type)
          this.dataUpdate.id = item.id
          this.dataUpdate.selectedStt = item.status
          this.dataUpdate.selectedResult = item.result
          this.dataUpdate.noteUpdate = item.note
          this.dataUpdate.noteUpdateArr = item.note?.split(', ')
          this.dataUpdate.noteUpdateType = item.type
          this.dataUpdate.noteDes = item.description
          this.dataUpdate.saleOfflineSignedImage = item.saleOfflineSignedImage
          this.dateRangeProcessing = {
            startDate: item.startIntend,
            endDate: item.endIntend,
          }
          const mappingData = (arr, type) =>
            arr.forEach(url => {
              const ar = { name: url, url, type, id: uuidv4() }
              this.fileImage.push(ar)
            })
          mappingData(item.images, 'images')
          this.purposesSelected = item.purposes?.[0] ?? null
          nextTick(() => {
            this.$bvModal.show('select-update-dialog')
          })
        } else {
          this.showFailMx('Bạn không có quyền thực hiện thao tác này')
        }
      },

      async onChangeType(data) {
        const res = mxItemAction.onChangeType(data)
        res.then(result => {
          this.dataUpdate.resonArr = result
        })
      },

      async updateCalendar(data) {
        try {
          this.showLoading = true
          const res = await CalendarAfsService.UpdateCalendarAFS(data)
          if (res.success) {
            this.showSuccessMx(res.message)
            this.loadData()
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.showLoading = false
          this.onHidden()
          this.$bvModal.hide('select-update-dialog')
        }
      },
      onHidden() {
        this.fileImage = []
        this.dataUpdate = {}
        this.purposesSelected = ''
        this.dateRangeProcessing = {}
        this.dataUpdate.noteUpdateArr = []
      },
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },

      async loadSubordinate() {
        try {
          const res = await StaffService.getStaffByIdSuperior({ userId: currentUser.userId })
          if (res.code === 1000) {
            this.dataStaff =
              res.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? []
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      handleConfirmCancel() {
        if (this.$refs.popupConfirmCancelRef) {
          this.$refs.popupConfirmCancelRef.show(this.taskInfo)
        }
      },
      getTiming(endCallIoTime, createCallIoTime) {
        if (!endCallIoTime) return ''
        const end = moment(endCallIoTime)
        const start = moment(createCallIoTime)
        const duration = moment.duration(end.diff(start))
        return `${pad(duration.hours(), 2, '0')}:${pad(duration.minutes(), 2, '0')}:${pad(
          duration.seconds(),
          2,
          '0'
        )}`
      },
      async listenRecord(id) {
        this.isLoading = true
        try {
          const res = await CallIoService.getRecording(id)
          window.open(res.data.url, '_blank')
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      },
      detailCall(id) {
        const routeData = this.$router.resolve({ path: `/call-io/${id}` })
        window.open(routeData.href, '_blank')
      },
      async fetchResultStatusCall() {
        try {
          const params = {
            taskId: this.id,
            task: (this.taskInfo.purposes && this.taskInfo.purposes[0]) || '',
            taskGroup: this.taskInfo.type || '',
          }
          const response = await CallIoService.getResultStatusCall(params)
          this.resultStatusCalls = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async fetchHistory() {
        try {
          const params = {
            page: 1,
            size: 20,
            customerId:
              (this.taskInfo.customerInfoRes && this.taskInfo.customerInfoRes.customerId) ||
              (this.taskInfo.merchantOwnerInfo && this.taskInfo.merchantOwnerInfo.merchantOwnerId),
            taskId: this.id,
          }
          const response = await CallIoService.getHistoryCallIo(params)
          this.historyCall = response.data.list
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    // box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 4px 16px 0px #0000001f !important;
    padding: 16px;
    border-radius: 10px;

    .cursor-pointer {
      cursor: pointer;
    }

    .header-section {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      position: relative;
      margin-left: 10px;

      &::before {
        content: ' ';
        position: absolute;
        width: 4px;
        height: 24px;
        background: #13569f;
        left: -10px;
      }
    }

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 12px;
      margin-top: 6px;
      padding-top: 6px;

      &:first-child {
        margin-top: 0;
      }

      .statusString- {
        width: Hug (61px) px;
        height: Hug (19px) px;
        padding: 2px 8px 2px 8px;
        gap: 8px;
        border-radius: 4px 0px 0px 0px;
        opacity: 0px;
        background: #0056f6;
      }

      & + .form-item {
        // border-top: 1px dotted #ddd;
        border-top: 1px dotted #edf1fa;
      }

      .form-label {
        font-weight: 500;
        font-size: 14px;
        color: #76809b;

        &::after {
          content: ':';
        }

        .icon-arrow {
          width: 30px;
          font-size: 18px !important;
          font-weight: 700;

          svg {
            font-size: 20px !important;
            color: '#2A2A2A';
            font-weight: 700;
          }
        }

        .un-after {
          &::before {
            content: '';
          }
        }
      }

      .form-label-collection {
        font-weight: 500;
        font-size: 14px;
      }

      .form-input {
        width: 68%;
        min-width: 68%;
        // font-weight: 600;
        font-weight: 400;
        margin-left: 10px;
        color: #212633;
        font-size: 14px;

        .image-item {
          width: 100px;
          overflow: hidden;
          overflow-y: hidden;
          border-radius: 5px;
          padding: 2px;
          display: inline-block;

          & + .image-item {
            margin-left: 4px;
          }

          .image {
            border: 1px solid #ddd;
            cursor: pointer;
            height: 80px;
            overflow: hidden;
          }

          .file-name {
            margin-top: 2px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .no-image {
          color: #aaa;
        }

        .location-item {
          margin-top: 2px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .list-task {
        list-style: disc;
        padding-left: 30px;

        li {
          list-style: disc !important;
          // padding: 6px 0 !important;
          font-weight: 400;
          font-size: 14px;

          .list-task-image {
            gap: 20px;

            p {
              font-weight: 400;
              font-size: 12px;
              color: gray;
            }

            img {
              border-radius: 5px;
              width: 60px;
              height: 55px;
              border: 1px 0px 0px 0px;
            }

            .no-data {
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>
